/* eslint-disable */
import jwt from 'jsonwebtoken'
const originalFetch = window.fetch;

window.fetch = async (input, init = {}) => {
  if(input.startsWith("https://licenze.ubisell.ubi-co.com/devices/jwt")){
    const response = await originalFetch(input, init);
    return response;
  }
  const token = localStorage.getItem("token");
  if(!token || !isTokenValid(token.replace(/['"]+/g, ""))){
    const udid = localStorage.getItem('udid')
    const associazione = localStorage.getItem('associazione')
    let result = await originalFetch(`https://licenze.ubisell.ubi-co.com/devices/jwt?udid=${udid}&associazione=${associazione}`,{
      headers: {
        'x-sellogic-key': 'znKDKo5pOiiDpBOP3hu7f2gc01YxKYjYkUSXJ2pR'
      }
    })
    result = await result.json() 
    localStorage.setItem('token', result.token)
  }
  const headers = new Headers(init.headers || {});
  if (token) {
    headers.set("Authorization", `Bearer ${token.replace(/['"]+/g, "")}`);
  }

  const modifiedInit = {
    ...init,
    headers
  };

  try {
    const response = await originalFetch(input, modifiedInit);
    return response;
  } catch (error) {
    console.error("Errore nella richiesta:", error);
    throw error;
  }
};


function isTokenValid(token){
  const decoded = jwt.decode(token)
  if(!decoded || !decoded.exp) {
    return false}
  const now = Date.now() / 1000
  return decoded.exp > now;
}